module.exports = __webpack_public_path__ + "media/assets/information-3f42865aabe0fe52cae348129d3646393bf5786d5e2802d38b8e1dbc0d7d9344.png";